import { render, staticRenderFns } from "./IELTSTimeManagerComponent.vue?vue&type=template&id=46f76cdf&scoped=true&"
import script from "./IELTSTimeManagerComponent.vue?vue&type=script&lang=js&"
export * from "./IELTSTimeManagerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f76cdf",
  null
  
)

export default component.exports